import { render, staticRenderFns } from "./buyerPrepaidOrderStatList.vue?vue&type=template&id=267ac1f5&scoped=true&"
import script from "./buyerPrepaidOrderStatList.vue?vue&type=script&lang=js&"
export * from "./buyerPrepaidOrderStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ac1f5",
  null
  
)

export default component.exports